/* MARAYAN — scripts du thème */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 3200);
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
    $$('[data-cart-label]').forEach(function (el) { el.setAttribute('aria-label', 'Panier, ' + n + ' article' + (n > 1 ? 's' : '')); });
  }
  function money(cents) {
    var fmt = (window.MARAYAN && window.MARAYAN.moneyFormat) || '{{amount_with_comma_separator}} €';
    var v = (cents / 100).toFixed(2);
    var comma = v.replace('.', ',');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
              .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount\s*\}\}/, v);
  }

  /* Header : menu mobile et recherche */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-toggle]');
    if (!b) return;
    var el = document.getElementById(b.getAttribute('data-toggle'));
    if (!el) return;
    var open = el.hasAttribute('hidden');
    if (open) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    $$('[data-toggle="' + el.id + '"]').forEach(function (x) { x.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) { var f = el.querySelector('input, a, button'); if (f) f.focus(); }
    document.body.style.overflow = (open && el.classList.contains('mobile-menu')) ? 'hidden' : '';
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.mobile-menu:not([hidden]), .lightbox:not([hidden])').forEach(function (el) { el.setAttribute('hidden', ''); document.body.style.overflow = ''; });
    $$('details.facet[open]').forEach(function (d) { d.removeAttribute('open'); });
  });

  /* Vidéo d'accueil : lecture à la demande */
  $$('[data-play]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = document.getElementById(btn.getAttribute('data-play'));
      if (!v) return;
      if (v.paused) { v.play(); v.setAttribute('controls', ''); btn.hidden = true; }
    });
  });

  /* Sélecteur de quantité */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = b.getAttribute('data-qty') === '+' ? v + 1 : Math.max(parseInt(input.min || '1', 10), v - 1);
    if (input.max) v = Math.min(v, parseInt(input.max, 10));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Fiche produit ---------- */
  $$('[data-product]').forEach(function (wrap) {
    var data = JSON.parse(wrap.querySelector('[data-product-json]').textContent);
    var form = wrap.querySelector('form[data-product-form]');
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('[data-add]');
    var priceEl = wrap.querySelector('[data-price]');
    var msg = wrap.querySelector('[data-variant-msg]');
    var sticky = document.querySelector('[data-sticky-buy]');
    var optionCount = data.options.length;
    var current = null;
    var slides = $$('.gallery__slide', wrap), thumbs = $$('.thumb', wrap);

    function selected() {
      var vals = [];
      for (var i = 0; i < optionCount; i++) {
        var c = form.querySelector('input[name="option' + (i + 1) + '"]:checked');
        vals.push(c ? c.value : null);
      }
      return vals;
    }
    function findVariant(vals) {
      if (vals.indexOf(null) !== -1) return null;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < optionCount; j++) { if (v.options[j] !== vals[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return undefined;
    }
    function label(t) { btn.textContent = t; $$('[data-sticky-label]').forEach(function (s) { s.textContent = t; }); }
    function setDisabled(d) {
      btn.disabled = d;
      $$('[data-sticky-add]').forEach(function (s) { s.disabled = d; });
    }
    function update() {
      var vals = selected();
      var v = findVariant(vals);
      current = v || null;
      msg.hidden = true; msg.className = 'notice'; msg.textContent = '';
      if (v === null) {
        idInput.value = '';
        setDisabled(true); label(wrap.getAttribute('data-choose-label') || 'Choisissez un modèle');
        if (sticky) sticky.querySelector('[data-sticky-model]').textContent = 'Modèle non choisi';
        return;
      }
      if (v === undefined) {
        idInput.value = ''; setDisabled(true); label('Indisponible');
        msg.hidden = false; msg.textContent = 'Cette combinaison n’existe pas.';
        return;
      }
      idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + money(v.price);
      }
      $$('[data-sticky-price]').forEach(function (s) { s.textContent = money(v.price); });
      if (sticky) sticky.querySelector('[data-sticky-model]').textContent = v.title;
      if (v.available) {
        setDisabled(false); label('Ajouter au panier');
      } else {
        setDisabled(true); label('Épuisé');
        msg.hidden = false;
        msg.textContent = 'Ce modèle est épuisé pour le moment. Choisissez un autre modèle ou revenez plus tard.';
      }
      if (v.featured_media) showMedia(String(v.featured_media.id));
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    form.addEventListener('change', function (e) { if (e.target.name && e.target.name.indexOf('option') === 0) update(); });
    update();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current || !current.available) { update(); return; }
      btn.classList.add('is-loading');
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: parseInt(form.querySelector('[name="quantity"]').value, 10) || 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { msg.hidden = false; msg.className = 'notice notice--err'; msg.textContent = res.j.description || res.j.message || 'Ajout impossible.'; return; }
          return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
            setCount(c.item_count);
            toast('Ajouté au panier · ' + current.title);
          });
        })
        .catch(function () { msg.hidden = false; msg.className = 'notice notice--err'; msg.textContent = 'Erreur réseau. Réessayez.'; })
        .finally(function () { btn.classList.remove('is-loading'); });
    });
    $$('[data-sticky-add]').forEach(function (s) {
      s.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    });
    if (sticky) {
      var io = new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting); });
      io.observe(form.querySelector('.buy'));
    }

    /* Galerie */
    function showMedia(id) {
      slides.forEach(function (s) {
        var on = s.getAttribute('data-media-id') === id;
        s.classList.toggle('is-active', on);
        if (!on) { var vid = s.querySelector('video'); if (vid) vid.pause(); }
      });
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-media-id') === id ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-media-id')); }); });
    var sim = wrap.querySelector('[data-simulate]');
    if (sim) {
      var ids = sim.getAttribute('data-simulate').split(','), k = 0;
      sim.addEventListener('click', function () { k = (k + 1) % ids.length; showMedia(ids[k]); });
    }
    var lb = document.getElementById('lightbox');
    var zoom = wrap.querySelector('[data-zoom]');
    if (zoom && lb) {
      zoom.addEventListener('click', function () {
        var a = wrap.querySelector('.gallery__slide.is-active img');
        if (!a) return;
        lb.querySelector('img').src = a.getAttribute('data-zoom-src') || a.currentSrc || a.src;
        lb.querySelector('img').alt = a.alt;
        lb.removeAttribute('hidden'); lb.querySelector('button').focus();
      });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('button')) lb.setAttribute('hidden', ''); });
    }
  });

  /* Produits associés (recommandations Shopify) */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var inner = d.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim().length) el.innerHTML = inner.innerHTML;
    }).catch(function () {});
  });

  /* ---------- Collection : filtres ---------- */
  $$('[data-facets-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="checkbox"], select')) form.submit();
    });
  });
  $$('[data-facets-open]').forEach(function (b) {
    b.addEventListener('click', function () { var f = $('.facets'); f.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
  });
  $$('[data-facets-close]').forEach(function (b) {
    b.addEventListener('click', function () { $('.facets').classList.remove('is-open'); document.body.style.overflow = ''; });
  });
  document.addEventListener('click', function (e) {
    $$('details.facet[open]').forEach(function (d) { if (!d.contains(e.target) && window.innerWidth > 760) d.removeAttribute('open'); });
  });

  /* ---------- Panier ---------- */
  var cartRoot = $('[data-cart]');
  if (cartRoot) {
    var change = function (key, qty) {
      cartRoot.classList.add('is-loading');
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (c.status && c.status >= 400) { toast(c.description || 'Quantité indisponible.'); }
          window.location.reload();
        })
        .catch(function () { cartRoot.classList.remove('is-loading'); toast('Erreur réseau. Réessayez.'); });
    };
    cartRoot.addEventListener('change', function (e) {
      if (e.target.matches('[data-line-qty]')) change(e.target.getAttribute('data-key'), parseInt(e.target.value, 10) || 0);
    });
    cartRoot.addEventListener('click', function (e) {
      var r = e.target.closest('[data-remove]');
      if (r) change(r.getAttribute('data-key'), 0);
    });
    var promo = $('[data-promo]');
    if (promo) {
      promo.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = promo.querySelector('input').value.trim();
        var out = $('[data-promo-msg]');
        if (!code) return;
        out.hidden = false; out.className = 'notice'; out.textContent = 'Vérification…';
        fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
          .then(function () { return fetch(root + 'cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var found = (c.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code.toUpperCase(); })[0];
            if (found && found.applicable) {
              sessionStorage.setItem('marayan-promo', 'Code ' + found.code + ' appliqué.');
              window.location.reload();
            } else {
              out.className = 'notice notice--err';
              out.textContent = found ? 'Ce code n’est pas applicable à votre panier (conditions non remplies).' : 'Code inconnu ou expiré.';
            }
          })
          .catch(function () { out.className = 'notice notice--err'; out.textContent = 'Erreur réseau. Réessayez.'; });
      });
      try {
        var saved = sessionStorage.getItem('marayan-promo');
        if (saved) { var o = $('[data-promo-msg]'); o.hidden = false; o.className = 'notice notice--ok'; o.textContent = saved; sessionStorage.removeItem('marayan-promo'); }
      } catch (err) {}
    }
  }
})();
